'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './main.routes';
import mainLogged from './main.component';
import insurances from './insurances/insurances.component';
import insuranceOffers from './insuranceOffers/insuranceOffers.component';
import insurancesOther from './insurancesOther/insurancesOther.component';
import insuranceOther from './insuranceOther/insuranceOther.component';
import insurance from './insurance/insurance.component';
import insuranceNnwList from './insurance-nnw-list/insurance-nnw-list.component';
import insuranceNnwDetails from '../main/insurance-nnw-details/insurance-nnw-details.component';

import sfNgMessages from '../../components/sf-ng-messages/sf-ng-messages.directive';
import peselValidator from '../../directive/pesel-validator/peselValidator';
import subscribeList from './subscribe-list/subscribe-list.component';
import lotosCards from './lotos-cards/lotos-cards.component';


export default angular.module('ngOskCrmApp.main', [uiRouter, mainLogged, sfNgMessages, peselValidator,
  insurances, insuranceOffers, insuranceNnwList, insuranceNnwDetails, insurance, insurancesOther, insuranceOther, lotosCards, subscribeList])
  .config(routing)
  .name;



// WEBPACK FOOTER //
// ./client/app/main/main.js